import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../_components/common/Navbar";
import Header from "../_components/common/Header";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ProtectedRoutesOutlet = () => {
  const auth = { token: localStorage.getItem("access_token_PA_Admin") };

  const [margin, setMargin] = useState(0);
  const reduxState = useSelector((state) => state.sidebar);

  useEffect(() => {
    if (reduxState.isExpended) {
      setMargin(260);
    } else {
      setMargin(104);
    }
  }, [reduxState]);
  // const auth = { token: "Authenticated" };
  // const auth = { token: null };
  return auth.token ? (
    <>
      {/* Header | Footer | Drawer for Protected Routes add here */}
      <header className="App-header">
        <Header />
        <Navbar />
      </header>
      <div
        className="parent-component"
        style={{ marginLeft: margin + 60, marginRight: 60 }}
      >
        <Outlet />
      </div>
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutesOutlet;
